<auth-card-layout>
    <div class="auth-head">
        <img class="auth-logo" src="images/logo.png" alt="RapiDocs" />
        <h1 class="title ra-header-s">{{ 'auth.login.title' | translate }}</h1>
        <p class="message ra-label-s content-secondary">{{ 'auth.login.message' | translate }}</p>
    </div>

    <div class="social-login-container">
        <div #googleButtonHost class="google-button-host"></div>

        <!--
            Botão custom da Apple: o HIG permite botão próprio desde que mantenha o
            logo oficial, o wording aprovado ("Continuar com Apple") e o contraste
            (preto no tema claro, branco no escuro). Diferente do app, aqui ele não
            é escondido por plataforma — quem criou a conta pela Apple no iPhone
            precisa conseguir entrar pelo site em qualquer sistema.
        -->
        @if (isAppleAvailable) {
            <button
                type="button"
                class="apple-button"
                [testId]="'button-login-apple'"
                [disabled]="loading()"
                (click)="loginWithApple()">
                @if (appleLoading()) {
                    <ra-loading [size]="'small'" />
                } @else {
                    <ra-icon [icon]="'apple'" [varColor]="'currentColor'" [size]="18" />
                }

                <span class="ra-label-s bold">
                    {{ 'auth.login.continueWithApple' | translate }}
                </span>
            </button>
        }
    </div>

    <div class="separator">
        <span class="line"></span>
        <span class="label">{{ 'auth.login.or' | translate }}</span>
        <span class="line"></span>
    </div>

    <form class="form-login" [formGroup]="formGroup">
        <ra-input
            type="email"
            formControlName="email"
            [id]="'input-email'"
            [label]="'auth.login.emailLabel' | translate"
            [placeholder]="'auth.login.emailPlaceholder' | translate"
            [leftIcon]="'email'" />

        <ra-input
            formControlName="password"
            [label]="'auth.login.passwordLabel' | translate"
            [id]="'input-password'"
            [placeholder]="'auth.login.passwordPlaceholder' | translate"
            [type]="isPasswordVisible() ? 'text' : 'password'"
            [leftIcon]="'lock'"
            [rightIcon]="isPasswordVisible() ? 'eye-slash' : 'eye'"
            (rightIconClick)="isPasswordVisible.set(!isPasswordVisible())"
            (enterKeyPress)="login()" />
    </form>

    <a class="forgot-password ra-label-s" [routerLink]="['/auth/forget-password']">
        {{ 'auth.login.forgotPassword' | translate }}
    </a>

    <ra-button
        [id]="'button-login'"
        [label]="'auth.login.submit' | translate"
        [loading]="loading()"
        (click)="login()" />

    <div class="container-text-link">
        <p class="text ra-label-s">{{ 'auth.login.noAccount' | translate }}</p>
        <a
            type="button"
            class="link-button ra-label-s"
            [testId]="'link-create-account'"
            (click)="navigateToCreateAccount()">{{ 'auth.login.createAccount' | translate }}</a>
    </div>

    <div class="container-text-link accept-invite">
        <p class="text ra-label-s">{{ 'auth.login.acceptInviteQuestion' | translate }}</p>
        <a
            class="link ra-label-s"
            [testId]="'link-accept-invitation'"
            routerLink="/auth/accept-invitation">{{ 'auth.login.acceptInviteLink' | translate }}</a>
    </div>
</auth-card-layout>

<banner />
